import { combineEpics } from 'redux-observable';
import { fetchAllVendorsEpic } from '@/store/epics/staff/assets/vendors/fetch-all-vendors';
import { createVendorEpic } from '@/store/epics/staff/assets/vendors/create-vendor.epic';

export const combinedVendorsEpics = combineEpics(
    fetchAllVendorsEpic,
    createVendorEpic,
);
